/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.reportqueries.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.reportqueries = {};
proto.witbooking.backoffice.reportqueries.v1 = require('./reportqueries_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueriesAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueriesAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest,
 *   !proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse>}
 */
const methodDescriptor_ReportQueriesAPI_GetReportQueries = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.reportqueries.v1.ReportQueriesAPI/GetReportQueries',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest,
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse,
  /**
   * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest,
 *   !proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse>}
 */
const methodInfo_ReportQueriesAPI_GetReportQueries = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse,
  /**
   * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueriesAPIClient.prototype.getReportQueries =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.reportqueries.v1.ReportQueriesAPI/GetReportQueries',
      request,
      metadata || {},
      methodDescriptor_ReportQueriesAPI_GetReportQueries,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueriesAPIPromiseClient.prototype.getReportQueries =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.reportqueries.v1.ReportQueriesAPI/GetReportQueries',
      request,
      metadata || {},
      methodDescriptor_ReportQueriesAPI_GetReportQueries);
};


module.exports = proto.witbooking.backoffice.reportqueries.v1;

